import React from "react";
import styled from "styled-components";

export interface TableWrapperProps {
  children: React.ReactNode;
  fullHeight?: boolean;
}

const StyledTableWrapper = styled.div<{ fullHeight?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  overflow-x: auto;
  display: flex;
  flex-direction: column;

  ${({ fullHeight }) =>
    fullHeight &&
    `
    flex: 1;
    height: 100%;
    overflow-y: auto;
  `}

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.sm};
  }
`;

export const TableWrapper: React.FC<TableWrapperProps> = ({ children, fullHeight }) => {
  return <StyledTableWrapper fullHeight={fullHeight}>{children}</StyledTableWrapper>;
};